import React, { useState, useEffect } from 'react';
import { Box, InputLabel, FormControl, MenuItem, Select } from '@mui/material';
import { fetch_roles } from '../../shared/ApiEndpoint';
import axiosInstance from '../../../utils/axiosInstance';
import { updateURLFilters } from '../../../utils/updateURLFilters';


export default function FilterDropdown({setSelectedRoleId,selectedRoleId,fetch_Users,searchTerm,currentPage,searchParam,setSearchParam,roles}) {


  
  const handleChange = (event) => {
    const selected = event.target.value;
    setSelectedRoleId(selected);
      fetch_Users(searchTerm, currentPage, selected);
      updateURLFilters(searchParam, setSearchParam, { role: selected });
  };

  

  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl fullWidth variant="outlined" size='small'>
        <InputLabel id="role-label">Filter</InputLabel>
        <Select
          labelId="role-label"
          id="role-select"
          value={selectedRoleId}
          label="Filter"
          onChange={handleChange}
        >
          <MenuItem value="all">All</MenuItem>
          {roles.map((r) => (
            <MenuItem key={r.id} value={r.role_id}>
              {r.rolename}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
